import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { URLREDEEMGIFTCARDCODE } from '../../../config/setup/setup';
import {
  GIFT_CARD_PLACEHOLDER,
  GIFT_CARD_BUTTON,
  GIFT_CARD_RESPONSE,
} from '../../../config/text/text';
import { getWallet } from '../../../redux/actions/wallet';
import ButtonForm from '../../_generic/button/CTAButton';
import InputForm from '../../_generic/input/Input';
import useToast from '../../_generic/toast/UseToast';
import { redeemGiftCode } from '../services/services';

const GiftForm = ({ className }) => {
  const dispatch = useDispatch();
  const [code, setCode] = useState('');
  const [isDisabled, setDisabled] = useState(false);
  const toast = useToast();
  const hasError = useSelector((state) => state.wallet.hasError);
  const toastErrorClass = 'toast-error';

  useEffect(() => {
    if (!code && !isDisabled) setDisabled(true);
    if (code && code.length && isDisabled) setDisabled(false);
  }, [code, isDisabled]);

  const getUserWallet = () => {
    const { success, error } = GIFT_CARD_RESPONSE.wallet;
    dispatch(getWallet())
      .then(() => {
        return hasError
          ? toast.addToast(error, toastErrorClass)
          : toast.addToast(success, 'toast-info');
      })
      .catch(() => toast.addToast(error, toastErrorClass));
  };

  const redeemGift = async (event) => {
    const { success, error } = GIFT_CARD_RESPONSE.redeem;
    event.preventDefault();

    const response = await redeemGiftCode(URLREDEEMGIFTCARDCODE, code);
    setCode('');
    if (response.status !== (200 || 202)) {
      toast.addToast(response.data.message || error, toastErrorClass);

      return;
    }
    toast.addToast(success, 'toast-success');
    getUserWallet();
  };

  const setRedeemCode = (event) => {
    setCode(event.target.value);
  };

  return (
    <form className={className} onSubmit={(event) => redeemGift(event)}>
      <InputForm
        extraClasses="text-center"
        inputValue={code}
        name="redeem"
        onChangeFunction={setRedeemCode}
        placeholder={GIFT_CARD_PLACEHOLDER}
        type="text"
      />
      <ButtonForm
        className="uppercase full-width"
        disabled={isDisabled}
        onClick={redeemGift}
        type="submit"
      >
        {GIFT_CARD_BUTTON}
      </ButtonForm>
    </form>
  );
};

GiftForm.propTypes = {
  className: PropTypes.string,
};

export default GiftForm;
